import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import useAuth from "./hooks/useAuth";
import ProgressBar from "./components/ProgressBar";

const MainLayout = ({ children }) => {
    const { user } = useSelector((state) => state.auth);
    const isAuthenticated = useMemo(() => {
        return !!user;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { isLoggedIn } = useAuth({ isDeepLinked: true, isAuthenticated });

    return <>{!isLoggedIn && !isAuthenticated ? <ProgressBar /> : <>{children}</>}</>;
};

export default MainLayout;